// extracted by mini-css-extract-plugin
module.exports =  {"search":"b3gzkQ5INTUdJP1foX1A","placeholder":"A_p76JMVGHJtZ7c4TOVu"};